module.exports = __webpack_public_path__ + "img/female.db01a20d.svg";